// import Crud from '../views/ImageCarousel/Crud'
import Entity from '../views/ImageCarousel/Add'

let routes = {
    path: '/image_carousels',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/image_carousels/add',
            name: 'NewCbo',
            component: Entity
        },
        {
            path: '/image_carousels/edit/:id?',
            name: 'EditCbo',
            component: Entity
        },
        // {
        //     path: '/image_carousels',
        //     name: 'list-imagem',
        //     component: Crud,
        //     meta: {
        //         pageTitle: 'Lista de image_carouselss',
        //         breadcrumb: [
        //             {
        //                 text: 'image_carouselss',
        //                 active: true,
        //             },
        //         ],
        //     },
        // },
    ]
};


export default routes
